import { combineReducers } from "redux";
import themeReducer from "./App.Theme.Reducer";
import adminReducer from "./pages/admin/Admin.Reducer";

export default combineReducers({
  admin: adminReducer,
  theme: themeReducer
});
